import { createAsyncAction } from "../../utils/actionCreators";

export const types = {
  LISTAR_DOCUMENTOS_ERRO: "@@administracao/LISTAR_DOCUMENTOS_ERRO",
};

export const actions = {
  listarDocumentosErro: createAsyncAction(types.LISTAR_DOCUMENTOS_ERRO),
};
